export const AUTO_ADJUSTMENT_RULE_PERMISSIONS = {
  AUTO_ADJUSTMENT_VIEW: 'AUTO_ADJUSTMENT_VIEW',
  AUTO_ADJUSTMENT_WRITE: 'AUTO_ADJUSTMENT_WRITE',
  AUTO_ADJUSTMENT_DELETE: 'AUTO_ADJUSTMENT_DELETE',
};
